
ko.bindingHandlers.summernote = {
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        var value = ko.unwrap(valueAccessor());
        var $element = $(element);
        var height = allBindings.get('height') || 480;
        $element.html(value).summernote({
            height: height, // set the editable area's height
            callbacks: { // added for V0.7.0
                onChange: function (contents) {
                    valueAccessor()(contents);
                }
            },
            toolbar: [
                ['style', ['bold', 'italic', 'underline']],
                ['font', [/*'fontname', 'fontsize',*/ 'color']],
                ['para', ['ul', 'ol', 'paragraph', 'height']],
                ["insert", ["hr", "link", "picture", "table"]],
                ["view", ["codeview", "fullscreen", "help"]]
            ],
        });
    }
};